enum WellevateAuthorizeStatus {
  CHECK_INBOX = "CheckInbox",
  SIGN_IN = "SignIn",
  SIGN_UP = "SignUp",
  EMAIL_CAPTURE = "EmailCapture",
  NOT_ELIGIBLE = "NotEligible",
}

export { WellevateAuthorizeStatus };
